import { Store, combineReducers } from 'redux';
import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import { moduleNamespace } from './config.store';
import reducers from '@Reducers';
import rootSaga from '../sagas';
import {
  sagas as sharedSagas,
  reducers as sharedReducers,
} from '@innovyze/stylovyze';
import libAmCommon from '@innovyze/lib-am-common/Reducers';
import libAmCommonSaga from '@innovyze/lib-am-common/Sagas';
import { all } from 'redux-saga/effects';
import {
  moduleNamespace as mapUiNamespace,
  reducers as mapUiReducers,
  sagas as mapUiSagas,
} from '@innovyze/map-components';

const sagaMiddleware = createSagaMiddleware();

declare global {
  interface Window {
    store: Store;
    Cypress: object;
  }
}

const store = configureStore({
  reducer: combineReducers({
    [moduleNamespace]: reducers,
    [mapUiNamespace]: mapUiReducers,
    ...sharedReducers,
    libAmCommon,
  }),
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({ thunk: false }).concat(sagaMiddleware),
  devTools: true,
});

const masterRootSaga = function* () {
  yield all([rootSaga(), sharedSagas(), libAmCommonSaga(), mapUiSagas()]);
};
sagaMiddleware.run(masterRootSaga);

if (window.Cypress) {
  window.store = window.store || {};
  window.store = store;
}

export default store;
